export function formatDuration(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (hours > 0) {
    return `${hours} h ${minutes.toString().padStart(2, '0')} min`;
  }
  if (minutes > 0) {
    return `${minutes} min${secs > 0 ? ` ${secs} s` : ''}`;
  }
  return `${secs} s`;
}

/** Etiqueta corta para la viñeta lateral (texto vertical). */
export function formatDurationCompact(totalSeconds: number): string {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  if (hours > 0) {
    return minutes > 0 ? `${hours}h${minutes}m` : `${hours}h`;
  }
  if (minutes > 0) {
    return secs > 0 ? `${minutes}m${secs}s` : `${minutes} min`;
  }
  return `${secs} s`;
}

export function secondsFromHoursMinutes(hours: number, minutes: number): number {
  return Math.max(0, Math.floor(hours) * 3600 + Math.floor(minutes) * 60);
}

export function splitSecondsToHoursMinutes(totalSeconds: number): { hours: number; minutes: number } {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  return {
    hours: Math.floor(seconds / 3600),
    minutes: Math.floor((seconds % 3600) / 60),
  };
}
